import React from "react";
import {Routes,Route} from 'react-router-dom'

import Start from "./start";
import Koniec from "./koniec"
//import LogowanieModal from "../OknaModal/modalLogin";
import AktywneKonkursy from "../Konkursy/aktywneKonkursy";
import Konkurs from "../Konkursy/konkurs";
//import TestKonkurs from "./kontrola";
import Regulamin from "./regulamin_new";
import DostPytan from "../Pytania/dostepnePytania";
//import { useDispatch} from 'react-redux'
//import { modOpcje } from '../Magazyn/kreatorAkcji'
const Strona  = (dane) => { 
//  const dispach = useDispatch()

//  function StatusTest() {
//    dispach(modOpcje({start:false}))
//    return( <TestKonkurs/>)
//  }
        return (
            <Routes>
              <Route exact path='/'   element={<AktywneKonkursy/>}/>
              <Route exact path='/konkurs'   element={<Regulamin/>}/>
              <Route  path='/home'    element={<Konkurs/>}/>
              <Route  path='/start'   element={<Start/>}/>
              <Route  path='/pytanie' element={<DostPytan/>}/>
              <Route  path='/koniec'  element={<Koniec/>}/>
            </Routes>
        )
    }

export default Strona
            // <Route  path='/test'    element={<StatusTest/>}/>